var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import media from '../../utils/media';
export const NavigationLink = styled((_a) => {
    var { navigationType, ariaLabel, external, href } = _a, rest = __rest(_a, ["navigationType", "ariaLabel", "external", "href"]);
    const newProps = Object.assign({}, rest);
    if (ariaLabel) {
        newProps['aria-label'] = ariaLabel;
    }
    if (external) {
        newProps.href = href;
    }
    return external ? React.createElement("a", Object.assign({}, newProps)) : React.createElement(NavLink, Object.assign({}, newProps));
}) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-style: normal;
  font-size: ${({ navigationType }) => (navigationType === 'secondary-navigation' ? '14px' : '16px')};
  line-height: 24px;
  color: ${({ theme }) => theme.primaryBlack};
  display: flex;
  align-items: center;
  width: 100%;
  ${media.mobile} {
    font-size: 14px;
    ${({ navigationType }) => (navigationType === 'secondary-navigation' ? null : 'line-height: 22px')};
  }

  &:hover {
    color: ${({ theme }) => theme.primaryRed};
  }
`;
